import axios from "axios";

// In DEV (Emergent preview) REACT_APP_BACKEND_URL=https://warthive-gpu-tune.preview.emergentagent.com
// In PROD (francominer.com) REACT_APP_BACKEND_URL deve essere VUOTO (stringa "")
// così le chiamate API sono RELATIVE (/api/...) e usano lo stesso origin del
// frontend. Se viene lasciato il preview URL, in produzione si scatena CORS error.
//
// Per la build di produzione usare lo script ./build_production.sh o:
//   REACT_APP_BACKEND_URL='' yarn build
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach token from localStorage if present (fallback for environments that
// strip third-party cookies). The cookie path still works server-side.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("warthive_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Qualcosa è andato storto. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
